import CustomerRoutes from "./customer";

export default [
    ...CustomerRoutes,
];
